import React, { useState } from "react";
import moment from "moment";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  rowStyle2,
} from "../Utility/utility";
import download from "images/download.svg";
import "../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import { downloadITCIndividualExcel } from "./action";
import { useDispatch, useSelector } from "react-redux";
import MultiplePopup from "../Utility/MultiplePopup";
import NoData from "../Utility/NoData";
import GstinPopup from "./GstinPopup";

const Table = () => {
  const dispatch = useDispatch();
  const { itcTableData } = useSelector((store) => store.gstr2a2bNewITCReducer);
  const [open, setOpen] = useState(false);
  const [dialogName, setDialogName] = useState("");
  const [selectedRecord, setSelectedRecord] = useState([]);

  const handleDownload = (row) => {
    try {
      dispatch(downloadITCIndividualExcel(row));
    } catch (error) {
      console.error("Error in handleDownload:", error);
    }
  };

  const handleMultiple = async (row, type) => {
    try {
      if (type === "Multiple Gstins") {
        setSelectedRecord(Array.isArray(row.GSTIN) ? row.GSTIN : [row.GSTIN]);
      } else {
        setSelectedRecord(
          Array.isArray(row.RET_PERIOD) ? row.RET_PERIOD : [row.RET_PERIOD]
        );
      }
      setDialogName(type);
      setOpen(true);
    } catch (error) {
      console.error("Error in handleMultiple:", error);
    }
  };

  const gstinColumnFormatter = (cell, row) => {
    // Split GSTIN string by comma and filter out empty values
    const gstins =
      typeof row.GSTIN === "string"
        ? row.GSTIN.split(",")
            .map((g) => g.trim())
            .filter(Boolean)
        : [row.GSTIN];

    const isMultiple = gstins.length > 1;
    const displayText = isMultiple ? "Multiple" : gstins[0] || "";

    return (
      <div
        style={{
          width: "100%",
          cursor: isMultiple ? "pointer" : "default",
          textDecoration: isMultiple ? "underline" : null,
          fontWeight: isMultiple ? "bold" : "normal",
          fontSize: "11px",
        }}
        onClick={
          isMultiple ? () => handleMultiple(row, "Multiple Gstins") : null
        }
      >
        {displayText}
      </div>
    );
  };

  const periodColumnFormatter = () => {
    return (cell, row) => {
      // Split RET_PERIOD string by comma and filter out empty values
      const periods =
        typeof row.RET_PERIOD === "string"
          ? row.RET_PERIOD.split(",")
              .map((p) => p.trim())
              .filter(Boolean)
          : Array.isArray(row.RET_PERIOD)
          ? row.RET_PERIOD
          : [];

      const isMultiple = periods.length > 1;
      const displayText = isMultiple ? "Multiple" : periods[0] || "";

      return (
        <div
          style={{
            width: "100%",
            cursor: isMultiple ? "pointer" : "default",
            textDecoration: isMultiple ? "underline" : null,
            fontWeight: isMultiple ? "bold" : "normal",
            fontSize: "11px",
          }}
          onClick={
            isMultiple ? () => handleMultiple(row, "Multiple Periods") : null
          }
        >
          {displayText}
        </div>
      );
    };
  };

  const itcColumns = [
    {
      dataField: "GSTIN",
      text: "GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: gstinColumnFormatter,
    },
    {
      dataField: "RET_PERIOD",
      text: "Return Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: periodColumnFormatter(),
    },

    {
      dataField: "DOCUMENT_RANGE",
      text: "Document Date Range",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "DOCUMENT_RANGE"),
    },
    {
      dataField: "CREATED_DATE",
      text: "Generation Timestamp",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: (cell, row) => {
        return <>{moment(row.CREATED_DATE).format("DD/MM/YYYY HH:mm:ss")}</>;
      },
    },

    {
      dataField: "",
      text: "Action",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "20%",
      },
      formatter: (cell, row) => {
        return (
          <img
            onClick={() => handleDownload(row)}
            src={download}
            alt="delete"
            style={{ width: "16px", cursor: "pointer" }}
          />
        );
      },
    },
  ];

  return (
    <>
      {itcTableData?.length > 0 ? (
        <div
          className="light-border-gstr2a2bnew-table"
          style={{ marginTop: "0.7em" }}
        >
          <BootstrapTable
            keyField="ID"
            data={itcTableData}
            columns={itcColumns}
            rowStyle={rowStyle2}
          />

          {/* <MultiplePopup
            open={open}
            onClose={() => setOpen(false)}
            dialogName={dialogName}
            selectedRecord={selectedRecord}
          /> */}
          <GstinPopup
            open={open}
            onClose={() => setOpen(false)}
            dialogName={dialogName}
            selectedRecord={selectedRecord}
          />
        </div>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
